export default __webpack_public_path__ + "static/media/app-bar-logo.a2a82c1d.svg";